/**
 * Field-audit log entities (spec 0046 / request 0249).
 * Append-only tables in the org Postgres — actor and timestamp stamped by system-api.
 */
export const AUDIT_OPERATION = 'AuditOperation';
export const AUDIT_FIELD = 'AuditField';
export const AuditOpValues = ['create', 'update', 'delete'];
export const AuditSourceValues = [
    'user',
    'system',
    'import',
    'integration',
    'assistant',
];
export const AuditFieldLevelValues = ['full', 'names-only'];
//# sourceMappingURL=audit.js.map